var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.modules),function(module,code){return _c('module',{key:(code + "-module"),attrs:{"title":module.title,"code":code,"copy":module.copy,"submodules":module.submodules}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }